import { Menu } from 'antd'
import React, { memo } from 'react'
import { Link } from 'react-router-dom'

export interface MenuItem {
  path?: string
  title: string
  icon?: string
  custom?: string
  permission?: string
  children?: MenuItem[]
}
interface HeaderMenuProps {
  menus: MenuItem[]
}

export default memo<HeaderMenuProps>(function HeaderMenu(props) {
  const { menus = [] } = props

  return (
    <>
      <Menu mode='horizontal' className='main-menu' style={{ width: '100%' }}>
        {menus.map((menu) => (
          <Menu.Item key={menu.path}>
            <Link to={menu.path!}>{menu.title}</Link>
          </Menu.Item>
        ))}
      </Menu>
    </>
  )
})
